/**
 * Animated "speaking…" equaliser — shown beside whichever answer ERIO is
 * currently narrating, so it's obvious at a glance which response is playing.
 */
export const SpeakingIndicator = ({ className = "" }) => (
  <span className={`inline-flex items-end gap-[2px] ${className}`} data-testid="speaking-indicator" aria-label="Narrating">
    {[0, 0.15, 0.3, 0.45].map((d) => (
      <span key={d} className="ek-eq-bar rounded-full bg-current" style={{ animationDelay: `${d}s` }} />
    ))}
  </span>
);
